import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Menu from '../components/menu';
import Footer from '../components/footer';
import api from '../config/axios'; // Import your axios instance

function AboSuccess() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const sessionId = searchParams.get('session_id'); // Récupère l'ID de session si besoin
  const [message, setMessage] = useState('Votre compte Premium a été activé avec succès.');
  const [userId, setUserId] = useState<number | null>(null);

  useEffect(() => {
    const fetchUserId = async () => {
      try {
        const response = await api.get('users/me');
        setUserId(response.data.userId);
      } catch (error) {
        console.error('Erreur lors de la récupération de l\'ID utilisateur:', error);
      }
    };
    
    fetchUserId();
  }, []);

  useEffect(() => {
    const validateCheckoutSession = async () => {
      try {        
        
        //console.log('your userId:', userId, 'type:', typeof userId);
        //console.log('your sess:', sessionId, 'type:', typeof sessionId);

        if (sessionId && userId !== null) {
        
          const response = await api.post('/stripe/valid-checkout-session', { sessionId, userId });
          //console.log('Validation response:', response.data);
          setMessage('Votre compte Premium a été activé avec succès.');
        } else {

          setMessage('La session Stripe ou l\'utilisateur est manquant contact. Utilisez la page Contactez nous en indiquant problème.');

        }

      } catch (error) {
        console.error('Erreur lors de la validation de la session Checkout:', error);
        setMessage('Erreur lors de la validation de votre abonnement.');
      }
    };

    validateCheckoutSession();
  }, [sessionId, userId]);   

  return (
    <div className="flex flex-col min-h-screen">
      <Menu />
      <div className="flex-1 flex flex-col items-center justify-center bg-gray-100 p-4">
        <div className="bg-white p-8 rounded-lg shadow-lg text-center max-w-md w-full">
          <h1 className="text-3xl font-bold text-green-600 mb-4">Merci pour votre abonnement !</h1>
          <p className="text-lg text-gray-700 mb-4">{message}</p>          
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default AboSuccess;